import Vue from 'vue';
const EVENTS = {
    show_loading: 'show-loading',
    hide_loading: 'hide-loading',
    unauthorized_error: 'unauthorized-error',
    common_error: 'common-error',
    server_error: 'server-error',
    reject_order: 'reject-order',
    not_found: 'not-found',
    not_found_schedule: 'not-found-schedule',
    off_not_found_page: 'off-not-found-page',
    off_not_found_schedule_page: 'off-not-found-schedule-page',
    add_pickup_location: 'add-pickup-location',
    remove_pickup_location: 'remove-pickup-location',
    add_getOff_location: 'add-getOff-location',
    remove_getOff_location: 'remove-getOff-location',
};
const eventBus = new Vue();
export { eventBus, EVENTS };
